export { default } from "./BaseModal";
